var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 27,
    viewBox: "0 0 18 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09176 19.4295L4.10877 18.6923H0.871795C0.64058 18.6923 0.418836 18.5821 0.255343 18.3859C0.0918497 18.1897 0 17.9236 0 17.6462V9.27692C0 8.99947 0.0918497 8.73337 0.255343 8.53718C0.418836 8.34099 0.64058 8.23077 0.871795 8.23077H4.10877L10.8713 3.15902C11.0032 3.06004 11.1549 3.00526 11.3105 3.00036C11.466 2.99546 11.6198 3.04062 11.756 3.13114C11.8921 3.22167 12.0055 3.35427 12.0845 3.51517C12.1635 3.67607 12.2051 3.85941 12.2051 4.04616V7.10881L5.09176 19.4295ZM8.02204 21.6272L10.8713 23.7641C11.0032 23.863 11.1549 23.9178 11.3105 23.9227C11.466 23.9276 11.6198 23.8825 11.756 23.7919C11.8921 23.7014 12.0055 23.5688 12.0845 23.4079C12.1635 23.247 12.2051 23.0637 12.2051 22.8769V14.3819L8.02204 21.6272Z",
    fill: "#FF6060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3845 10.5966V18.6924C15.829 18.6924 16.9999 17.5214 16.9999 16.077V10.8462C16.9999 9.8337 16.4245 8.95557 15.5829 8.52094L14.3845 10.5966Z",
    fill: "#FF6060"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.7288,
    y: 0.527161,
    width: 2.14966,
    height: 28.4087,
    transform: "rotate(30 15.7288 0.527161)",
    fill: "#FF6060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/volume_mute.f394a4e7062cae719ab781dea51b9aa0.svg";
export { ForwardRef as ReactComponent };